<template>
  <div>

    <div @click="back()" style="height: 30px;width: 60px;display: flex;align-items: center;cursor: pointer;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M10.9825 3.58692L10.2867 2.89111L3.85938 9.3198L10.2867 15.7478L10.9825 15.052L5.24986 9.31938L10.9825 3.58692Z"
          fill="#595959" />
      </svg>
      <span style="margin-left: 1px;margin-top: -2px;color: #595959;">返回</span>
    </div>

    <div style="height: 100%;width: 100%;">

      <div class="content-head">
        <div class="head-title">待披露</div>
        <div class="head-search">
          <!-- <el-input v-model="searchText" placeholder="证券简称或代码"></el-input> -->

          <div style="width: 70px;text-align: right;">交易所：</div>
          <el-select v-model="queryParam.node" placeholder="请选择">
            <el-option v-for="(item, index) in exchangeList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>

          <div style="width: 7px;"></div>

          <el-button @click="getData">搜索</el-button>
        </div>
      </div>

      <div class="table-box">
        <table cellspacing="0">
          <thead>
            <tr>
              <th>股票代码</th>
              <th>股票名称</th>
              <th>预约披露日期</th>
              <th>预约披露类型</th>
              <th>详情</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="tableData == null || tableData == undefined || tableData.length == 0">
              <tr>
                <td colspan="99">暂无数据</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ item.comCode }}</td>
                <td>{{ item.sname }}</td>
                <td>{{ toDate(item.publish_date) }}</td>
                <td>{{ item.publish_type }}</td>
                <td>
                  <div class="text-button-enable" @click="viewCompany(item)">分析</div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="paging">
        <!-- <div class="pading-total"> -->
        <!-- 共&nbsp;{{ pages }}&nbsp;页&nbsp;&nbsp;&nbsp;&nbsp;当前&nbsp;{{ queryParam.pageNum }}&nbsp;页 -->
        <!-- 共&nbsp;{{ total }}&nbsp;条 -->
        <!-- </div> -->
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 15, 20, 30, 40, 50]"
          :current-page="queryParam.page" :page-size="queryParam.num" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" class="paging-pages">
        </el-pagination>
      </div>

    </div>

    <div style="color:#9a9a9a; padding: 5px;margin-top: 30px;">
      免责声明：上述所有信息均基于市场公开数据，经数据自动处理技术和人工智能算法产生，碧湾将尽力但不能保证其绝对准确和可靠，且亦不会承担因任何不准确或遗漏而引起的任何损失或损害的责任。所有数据信息仅供参考，不构成任何投资建议，不代表碧湾观点，投资者据此操作，风险自担。
    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestIndustry } from '../../../../static/js/util';

export default {
  data() {
    return {
      searchText: '',
      queryParam: {
        node: 'all',
        page: 1,
        num: 10
      },
      exchangeList: [
        { name: '全A', value: 'all' },
        { name: '上交所', value: 'sh' },
        { name: '深交所', value: 'sz' },
        { name: '北交所', value: 'bj' },
      ],
      total: 1,
      pages: 1,
      tableData: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    back() {
      linkName(this, 'market');
    },
    toDate(date) {
      return date.substring(0, 4) + '-'
        + date.substring(4, 6) + '-'
        + date.substring(6, 8)
    },
    //获取数据
    getData() {
      // const loading = this.$loading({
      //     target: $('.table-box')[0],
      //     lock: true,
      //     text: '加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(255, 255, 255, 0.8)'
      // });
      sendRequestIndustry('/sina/onProduct' +
        '?node=' + this.queryParam.node +
        '&page=' + this.queryParam.page +
        '&num=' + this.queryParam.num,
        'get',
        null,
        res => {
          // loading.close();
          // console.log(res)
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
            this.pages = res.data.data.pages;
          }
        }, err => {
          // loading.close();
          console.log(err);
        })
    },
    viewCompany(row) {
      window.top.location = '/beawanHome/companyResearch/research?comCode=' + row.comCode + '&name=' + row.sname;
    },
    //每页多少条
    handleSizeChange(num) {
      this.queryParam.num = num;
      this.getData();
    },
    //换页
    handleCurrentChange(index) {
      this.queryParam.page = index;
      this.getData();
    }
  }
};
</script>
    
<style scoped>
@import "../../../../static/css/marketItemView.css";
</style>